import React, {lazy, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ParticleCanvas from './components/ParticleCanvas';
import Home from './pages/Home';
import Blog from './pages/Blog';
// import About from './pages/About';
import Contact from './pages/Contact';
import ChatbotWidget from './components/ChatbotWidget';
// import BlogAutomation from './pages/BlogAutomation';
import IPTools from './pages/IPTools';
import DevTools from './pages/DevTools';
import FileTools from './pages/FileTools';
import ToolsLanding from './pages/ToolsLanding';
import { HelmetProvider } from 'react-helmet-async';
import FinanceTools from './pages/FinanceTools';
import TextTools     from './pages/TextTools';
import AITools       from './pages/AITools';
import BusinessTools from './pages/BusinessTools';
import LoginPage      from './pages/LoginPage';
import PricingPage    from './pages/PricingPage';
import DashboardPage  from './pages/DashboardPage';
import { ProtectedRoute, TierGate, UpgradePrompt, AdminRoute } from './pages/ProtectedRoute';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import {AdBanner} from './pages/ProtectedRoute';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import VerifyRequiredPage from './pages/VerifyRequiredPage';


import HomePage         from './pages/portals/HomePage';
import JobSearchPortal  from './pages/portals/JobSearchPortal';
import FreelancerPortal from './pages/portals/FreelancerPortal';
import DeveloperPortal  from './pages/portals/DeveloperPortal';
import ToolsHub         from './pages/portals/ToolsHub';
import FinanceHub       from './pages/portals/FinanceHub';

import BlogIndex from './pages/blog/BlogIndex';
import BlogPost  from './pages/blog/BlogPost';
import CookieBanner from './components/CookieBanner';
import TermsPage from './pages/legal/TermsPage';
import PrivacyPage from './pages/legal/PrivacyPage';
// const FinanceTools    = lazy(() => import('./pages/FinanceTools'));
// const JobSearchPortal = lazy(() => import('./pages/portals/JobSearchPortal'));
// const BlogPost        = lazy(() => import('./pages/blog/BlogPost'));
// const TermsPage   = lazy(() => import('./pages/legal/TermsPage'));
// const PrivacyPage = lazy(() => import('./pages/legal/PrivacyPage'));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}
const Mapping = {
  'pdf-compress': <FileTools />,
  'pdf-merge': <FileTools />,
  'image-convert': <FileTools />,
  'ip': <IPTools />,
  'dev-tools': <DevTools />,
  'files': <FileTools />,
  'finance': <FinanceTools />,
  'text': <TextTools />,
  'ai': <AITools />,
  'business': <BusinessTools />,
  'www': <ToolsLanding />,
  'counter': <TextTools />,
  'case':    <TextTools />,
  'dedupe':  <TextTools />,
    'lorem':   <TextTools />,
    'wordcount': <TextTools />,
  'markdown':<TextTools />,
  'htmlenc': <TextTools />,
  'htmltomd': <TextTools />,
  'word-counter': <TextTools />,
  'case-converter':<TextTools />,


  'remove-duplicates':<TextTools />,


  'lorem-ipsum':<TextTools />,
  'markdown-preview':<TextTools />,
  'html-encoder':<TextTools />,
  'html-to-markdown':<TextTools />,
  'wordcount': <TextTools />,
  'myip': <IPTools />,
  'ip': <IPTools />,
  'ip-lookup': <IPTools />,
  'hostname': <IPTools />,
  'whois': <IPTools />,
  'blacklist': <IPTools />,
  'port-scanner': <IPTools />,
  'dns-lookup': <IPTools />,
  'user-agent': <IPTools />,
  'speed-test': <IPTools />,
  'fire': <FinanceTools />,
  'coast': <FinanceTools />,
  'fatfire': <FinanceTools />,
  'barista': <FinanceTools />,
  'windfall': <FinanceTools />,
  'purchase': <FinanceTools />,
  'compound': <FinanceTools />,
  'loan': <FinanceTools />,
  'mortgage': <FinanceTools />,



  //add from here
  'portfolio': <FinanceTools />,
  'rental': <FinanceTools />,
  'househack': <FinanceTools />,
  'caprate': <FinanceTools />,
  'cashoncash': <FinanceTools />,
  'savings': <FinanceTools />,
  'emergency': <FinanceTools />,
  'hsa': <FinanceTools />,
  'inflation': <FinanceTools />,
  'upwork': <FinanceTools />,
  'ev': <FinanceTools />,
  'sip': <FinanceTools />,
  'retirement': <FinanceTools />,
  'rrsp': <FinanceTools />,
  'tfsa': <FinanceTools />,
  'dividend': <FinanceTools />,
  'currency': <FinanceTools />,

  'image-convert': <FileTools />,
  'pdf-merge': <FileTools />,
  'pdf-compress': <FileTools />,
  'files': <FileTools />,
  'file-tools': <FileTools />,

  'json': <DevTools />,
  'json-formatter': <DevTools />,
  'text-diff': <DevTools />,
  'yaml': <DevTools />,
  'yaml-formatter': <DevTools />,
  'base64': <DevTools />,
  'base64-encode': <DevTools />,
  'base64-decode': <DevTools />,
  'url': <DevTools />,
  'url-encode': <DevTools />,
  'url-decode': <DevTools />,
  'jwt': <DevTools />,


  'uuid': <DevTools />,
  'hash': <DevTools />,
  'hmac': <DevTools />,
  'regex': <DevTools />,

  'invoice': <BusinessTools />,
  'invoice-generator': <BusinessTools />,
  'gst': <BusinessTools />,
  'vat': <BusinessTools />,
  'margin': <BusinessTools />,
  'profit': <BusinessTools />,
  'price-markup': <BusinessTools />,
  'freelance-rate': <BusinessTools />,
  'payroll': <BusinessTools />,




};
export default function App() {
          const hostname = window.location.hostname;

      const parts = hostname.split(".");
    
    const firstSubdomain=parts.length > 2 ? parts[0] : null;

    console.log("First subdomain:", Mapping[firstSubdomain]);
  return (
<HelmetProvider>
  <CookieBanner/>
      <ParticleCanvas />
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          {/* {firstSubdomain? <Route path="/" element={Mapping[firstSubdomain]} />: <Route path="/" element={<HomePage />} />} */}
          {<Route path="/" element={<HomePage />} />}

          <Route path="/home" element={<HomePage />} />

          {/* <Route path="/services" element={<Services />} /> */}
          {/* <Route path="/case-studies" element={<CaseStudies />} /> */}
          {/* <Route path="/open-source" element={<OpenSource />} /> */}
          {/* <Route path="/resources" element={<Resources />} /> */}
          {/* <Route path="/blog" element={<Blog />} /> */}
          {/* <Route path="/about" element={<About />} /> */}
          <Route path="/contact" element={<Contact />} />
          
          {/* <Route path="/blog/backend-architecture" element={<BlogArchitecture />} /> */}
          {/* <Route path="/blog/django-vs-fastapi" element={<BlogDjangoVsFastAPI />} /> */}
          {/* <Route path="/blog/automation" element={<BlogAutomation />} /> */}

          {/* <Route path="/blog/ai-workflows" element={<BlogAIWorkflows />} />
          <Route path="/blog/building-reliable-apis" element={<BlogReliableAPIs />} />
          <Route path="/blog/business-automation" element={<BlogAutomation />} /> */}


<Route path="/terms"   element={<TermsPage/>}/>
<Route path="/privacy" element={<PrivacyPage/>}/>
          <Route path="/tools/ip" element={<IPTools />} />

          <Route path="/tools/ip/:toolName" element={<IPTools />} />
          <Route path="/tools/dev" element={<DevTools />} />
          <Route path="/tools" element={<ToolsLanding />} />

          <Route path="/tools/dev/:toolName" element={<DevTools />} />
                    <Route path="/tools/ai/:toolName" element={<AITools />} />

          <Route path="/tools/files" element={<FileTools />} />
          <Route path="/tools/files/:toolName" element={<FileTools />} />

          <Route path="/tools/finance" element={<FinanceTools />} />
          <Route path="/tools/finance/:toolName" element={<FinanceTools />} />

          <Route path="/tools/text"     element={<TextTools />} />
          <Route path="/tools/text/:toolName" element={<TextTools />} />

          <Route path="/tools/ai"       element={<AITools />} />
          <Route path="/tools/ai/:toolName" element={<AITools />} />

          <Route path="/tools/business" element={<BusinessTools />} />
          <Route path="/tools/business/:toolName" element={<BusinessTools />} />


          <Route path="/login"     element={<LoginPage/>}/>
                    {/* <Route path="/login"     element={<HomePage/>}/> */}

          <Route path="/pricing"   element={<PricingPage/>}/>
          {/* <Route path="/pricing"   element={<LoginPage/>}/> */}

          <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
          <Route path="/reset-password"  element={<ResetPasswordPage/>}/>
          <Route path="/verify-email"    element={<VerifyEmailPage/>}/>
          <Route path="/verify-required" element={<VerifyRequiredPage/>}/>
          <Route path="/blog"       element={<BlogIndex/>}/>
<Route path="/blog/:slug" element={<BlogPost/>}/>

                  <Route path="/job-search"  element={
                     <ProtectedRoute requireTier="ai_tools">
                    <JobSearchPortal/>
                    </ProtectedRoute>
                    }/>
                  <Route path="/freelancer"  element={ <ProtectedRoute requireTier="ai_tools">
                    <FreelancerPortal/>
                  </ProtectedRoute>}/>
                  <Route path="/developer"   element={
                    <ProtectedRoute requireTier="ai_tools">
                    <DeveloperPortal/>
                    </ProtectedRoute>
                
                }/>
                  <Route path="/tools"       element={
                    <ProtectedRoute requireTier="ai_tools">
                    <ToolsHub/>
                    </ProtectedRoute>
                    }/>
                  <Route path="/finance"     element={
                    <ProtectedRoute requireTier="ai_tools">
                    <FinanceHub/>
                    </ProtectedRoute>
                    }/>

<Route path="/dashboard" element={
  <ProtectedRoute>
    <DashboardPage/>
  </ProtectedRoute>}/>
<Route path="/admin" element={
  <AdminRoute>
    <AdminDashboardPage/>
  </AdminRoute>}/>
<Route path="/tools/ai" element={
  <ProtectedRoute requireTier="ai_tools">
    <AITools/>
  </ProtectedRoute>
}/>
</Routes>
      </main>
              <AdBanner slot="tools-top"/>
      
      {/* <ChatbotWidget/> */}
      <Footer />
    </HelmetProvider>
  );
}
